<template>
  <div class="faqs">
    <div id="faqs" class="wrap">
      <div class="page-container">
        <div class="flex-col-vertical-bottom top-title">
          <div class="title">
            <h2>{{ $t('common.faqs') }}</h2>
            <h5>
              {{ $t('home.faqs.subtitle') }}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.mintme.com/coin/faq"
              >
                {{ $t('home.faqs.button-see-more') }}
              </a>
            </h5>
          </div>
        </div>

        <div class="qa-cards">
          <ul class="qa__contents">
            <li v-for="prop in Object.keys(faqs)" :key="prop">
              <div class="qa__contents--title" @click="openFAQ(prop)">
                <h3>{{ faqs[prop].title }}</h3>
                <div class="show-more-buttons">
                  <div
                    :class="faqs[prop].open ? 'faq-open' : ''"
                    class="animated-button"
                  >
                    <div class="bar bar1"></div>
                    <div class="bar bar2"></div>
                  </div>
                  <span
                    v-if="false"
                    :class="faqs[prop].open ? 'show-less' : 'show-more'"
                  >
                    {{ faqs[prop].open ? '-' : '+' }}
                  </span>
                </div>
              </div>
              <div
                :class="faqs[prop].open ? 'faq-open' : ''"
                class="qa__contents--content"
              >
                <div class="qa-text">
                  {{ faqs[prop].content }}
                  <a
                    :href="faqs[prop].link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ faqs[prop].linkText }}
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      faqs: {
        faq1: {
          open: false,
          title: this.$t('home.faqs.create-wallet.title'),
          content: this.$t('home.faqs.create-wallet.text'),
          linkText: this.$t('home.faqs.button-here'),
          link: 'https://www.mintme.com/coin/faq'
        },
        faq2: {
          open: false,
          title: this.$t('home.faqs.send-txs.title'),
          content: this.$t('home.faqs.send-txs.text'),
          linkText: this.$t('home.faqs.button-here'),
          link: 'https://www.mintme.com/coin/faq'
        },
        faq3: {
          open: false,
          title: this.$t('home.faqs.forgot-pwd.title'),
          content: this.$t('home.faqs.forgot-pwd.text'),
          linkText: this.$t('home.faqs.button-here'),
          link: 'https://www.mintme.com/coin/faq'
        }
      }
    };
  },
  methods: {
    openFAQ: function(faqToOpen) {
      this.faqs[faqToOpen].open = !this.faqs[faqToOpen].open;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'FaqsContainer.scss';
</style>
